import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';
import set from 'lodash/set';

const imageDomain = process.env.REACT_APP_IMG_DOMAIN;

const INIT_SEARCH = 'model/INIT_SEARCH';
export const initSearch = createAction(INIT_SEARCH);

const CHANGE = 'model/CHANGE';
export const change = createAction(CHANGE);

const CHANGE_VALIDATE = 'model/CHANGE_VALIDATE';
export const changeValidate = createAction(CHANGE_VALIDATE);

const GET_MODEL = 'model/GET_MODEL';
export const getModel = createAction(GET_MODEL, api.getRyvuss);

const SET_IMG = 'model/SET_IMG';
export const setImg = createAction(SET_IMG);

const initialState = {
	searchInfo: {},
	validate: {
		loan: false,
		advance: false,
	},
	manufactButtonText: '제조사',
	categoryButtonText: '차종',
	yearButtonText: '연식',
	manufactSelected: false,
	categorySelected: false,
	yearSelected: false,
	model: [],
	price: {},
	img: [],
	pageSize: 10,
	limitPage: 0,
};

export default handleActions(
	{
		[INIT_SEARCH]: (state, action) =>
			produce(state, (draft) => {
				set(draft, 'searchInfo', {
					...state.searchInfo,
					...action.payload,
				});
			}),

		[CHANGE]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				set(draft, ['searchInfo', name], value);
			}),

		[CHANGE_VALIDATE]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				set(draft, ['validate', name], value);
			}),

		...pender({
			type: GET_MODEL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { Nodes: nav } = data.iNav;
					const { pageSize } = state;

					let manufactButtonText = '제조사';
					const manufact = nav
						.filter((item) => item.Name === 'ModelCarType')[0]
						.Facets.filter((item) => item.Value === 'A')[0]
						.Refinements.Nodes.filter((item) => item.Name === 'MultiManufacturer')[0];
					const { IsSelected: manufactSelected } = manufact;
					const selectedManufact = manufact.Facets.filter((item) => item.IsSelected);
					const selectedManufactLeng = selectedManufact.length;

					if (manufactSelected) {
						if (selectedManufactLeng === 1) {
							manufactButtonText = selectedManufact[0].DisplayValue;
						} else {
							manufactButtonText = `${selectedManufact[0].DisplayValue} 외 ${selectedManufactLeng - 1}개`;
						}
					}

					let categoryButtonText = '차종';
					const category = nav.filter((item) => item.Name === 'Category')[0];
					const { IsSelected: categorySelected } = category;
					const selectedCategory = category.Facets.filter((item) => item.IsSelected);
					const selectedCategoryLeng = selectedCategory.length;

					if (selectedCategoryLeng) {
						if (selectedCategoryLeng === 1) {
							categoryButtonText = selectedCategory[0].DisplayValue;
						} else {
							categoryButtonText = `${selectedCategory[0].DisplayValue} 외 ${selectedCategoryLeng - 1}종`;
						}
					}

					let yearButtonText = '연식';
					const year = nav.filter((item) => item.Name === 'Year')[0];
					const { IsSelected: yearSelected } = year;

					if (year.IsSelected) {
						const minYear = year.LowerBound;
						const upperYear = year.UpperBound;

						if (minYear.substring(2, 4) === upperYear.substring(2, 4)) {
							yearButtonText = `${minYear.substring(2, 4)}년식`;
						} else {
							yearButtonText = `${minYear.substring(2, 4)}~${upperYear.substring(2, 4)}년식`;
						}
					}

					const { Facets } = nav
						.filter((item) => item.Name === 'ModelCarType')[0]
						.Facets.filter((item) => item.IsSelected)[0]
						.Refinements.Nodes.filter((item) => item.Name === 'ModelPath')[0];
					const model = Facets.map((item, index) => ({
						...item,
						cnt: index,
						loadImg: false,
						img: '',
					}));
					const limitPage = Math.ceil(model.length / pageSize);

					const price = nav.filter((item) => item.Name === 'Price' && item.Type === 'RangeAction')[0];

					set(draft, 'nav', nav || []);
					set(draft, 'manufactButtonText', manufactButtonText);
					set(draft, 'categoryButtonText', categoryButtonText);
					set(draft, 'yearButtonText', yearButtonText);
					set(draft, 'manufactSelected', manufactSelected);
					set(draft, 'categorySelected', categorySelected);
					set(draft, 'yearSelected', yearSelected);
					set(draft, 'model', model || []);
					set(draft, 'limitPage', limitPage);
					set(draft, 'price', price || {});
				}),
		}),

		[SET_IMG]: (state, action) =>
			produce(state, (draft) => {
				const { index, img } = action.payload;
				const target = state.model[index];

				set(draft, ['model', index], {
					...target,
					img: img || `${imageDomain}/carsdata/cars/cm_cardb/file/sample_car_main_none.gif`,
					loadImg: true,
				});
			}),
	},
	initialState,
);
